import { EnvVariable } from '../../../enums';
import { getStringEnvVariable } from '../../../utils';

export const Logo = () => (
  <div className="flex flex-col h-[40px] justify-between">
    <h1 className="typography-heading-2 text-text-primary">{getStringEnvVariable(EnvVariable.TITLE, 'Healthcare')}</h1>
    <h2 className="typography-title-5 text-global-neuchatel-50">BY AKTIIA</h2>
  </div>
);
